import { createElement, type ReactNode, Suspense } from 'react';

interface IAlwaysCaseRenderProps {
  available: boolean;
  value: number;
  quota: number;
}

interface IQuotaManagementComponentProps<TShow extends 'match' | 'always'> {
  show?: TShow;
  fallback?: ReactNode;
  render: TShow extends 'always' ? (props: IAlwaysCaseRenderProps) => ReactNode : () => ReactNode;
}

export const createQuotaManagementComponent =
  (useQuotaManagementImpl: () => IAlwaysCaseRenderProps) =>
  <TShow extends 'match' | 'always' = 'match'>({
    fallback,
    render,
    show = 'match' as TShow,
  }: IQuotaManagementComponentProps<TShow>) => (
    <Suspense fallback={fallback}>
      {createElement(function QuotaManagementComponentImpl() {
        const { available, value, quota } = useQuotaManagementImpl();
        if (show === 'always') {
          return render({ available, value, quota });
        }
        return value < quota ? render(undefined as never) : null;
      })}
    </Suspense>
  );
